import { render, staticRenderFns } from "./CoverDetailsPage.vue?vue&type=template&id=1a78affa&scoped=true&"
import script from "./CoverDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CoverDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./CoverDetailsPage.vue?vue&type=style&index=0&id=1a78affa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78affa",
  null
  
)

export default component.exports